module.exports = {
    //REST: process.env.NODE_ENV === 'production' ? 'https://rest.amateum.com/' : 'http://localhost:3003/',
    REST: process.env.NODE_ENV === 'production' ? 'https://rest.amateum.com/' : 'http://localhost:3003/',
    //REST: 'https://rest.amateum.com/',
    //SOCK: process.env.NODE_ENV === 'production' ? 'https://sock.amateum.com' : 'http://localhost:3001',
    SOCK: 'https://sock.amateum.com',
    SHEETS: process.env.NODE_ENV === 'production' ? 'https://sheets.amateum.com' : 'http://localhost:3004/'
}
